export enum subscriptionPageState {
  default = "default",
  paymentMethodDetails = "paymentMethodDetails",
  addPaymentMethod = "addPaymentMethod",
  invoiceDetails = "invoiceDetails",
  movePaymentMethodMRToAR = "movePaymentMethodMRToAR",
  cancelSubscriptionSuccess = "cancelSubscriptionSuccess",
  cancelSubscriptionFailure = "cancelSubscriptionFailure",
}
